import { createContext } from 'react';

export type RealtimeStatus = 'desconectado' | 'conectando' | 'conectado';

/** Frame cru da fila do usuario; cada feature interpreta o payload que conhece. */
export type RealtimeEvento = {
  tipo: string;
  payload: Record<string, unknown>;
};

export type RealtimeContextValue = {
  status: RealtimeStatus;
  conectado: boolean;
  /** Retorna a funcao de cancelamento da assinatura. */
  subscribe: (handler: (evento: RealtimeEvento) => void) => () => void;
  publish: (destino: string, body: unknown) => void;
};

/** Fora do provider o canal fica inerte, sem quebrar quem so escuta. */
export const realtimeInerte: RealtimeContextValue = {
  status: 'desconectado',
  conectado: false,
  subscribe: () => () => {},
  publish: () => {},
};

export const RealtimeContext = createContext<RealtimeContextValue>(realtimeInerte);
